import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17795884"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "panelRef",
  class: "nge-notif-panel"
}
const _hoisted_2 = { class: "nge-notif-topbar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-notif-title" }, "🔔 Notifications", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-notif-topbar-actions" }
const _hoisted_5 = {
  key: 0,
  class: "nge-notif-confirm"
}
const _hoisted_6 = {
  key: 1,
  class: "nge-notif-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "nge-notif-card-row" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "nge-notif-card-content" }
const _hoisted_11 = { class: "nge-notif-card-header" }
const _hoisted_12 = {
  key: 0,
  class: "nge-notif-unread-dot"
}
const _hoisted_13 = { class: "nge-notif-card-title" }
const _hoisted_14 = { class: "nge-notif-time" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "nge-notif-card-body nge-notif-card-body--preview" }
const _hoisted_18 = {
  key: 2,
  class: "nge-notif-empty"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "nge-notif-detail" }
const _hoisted_21 = { class: "nge-notif-detail-topbar" }
const _hoisted_22 = { class: "nge-notif-detail-time" }
const _hoisted_23 = { class: "nge-notif-detail-scroll" }
const _hoisted_24 = {
  key: 0,
  class: "nge-notif-detail-image"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "nge-notif-detail-text" }
const _hoisted_27 = { class: "nge-notif-detail-title" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            ($setup.backend.unreadNotificationCount > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "nge-notif-mark-all",
                  onClick: _cache[0] || (_cache[0] = $event => ($setup.backend.markAllNotificationsRead()))
                }, "Mark all read"))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Separate from \"mark all read\" on purpose: read state controls the\n             unread pip, this clears the feed. Only hides them for THIS user —\n             the underlying notification rows are untouched. "),
            ($setup.backend.notifications.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "nge-notif-delete-all",
                  onClick: _cache[1] || (_cache[1] = $event => ($setup.confirmDeleteAll = true)),
                  title: "Delete all notifications (only affects your feed)"
                }, "Delete all"))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: "nge-notif-close",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($setup.emit('hide')), ["stop"]))
            }, "×")
          ])
        ]),
        _createCommentVNode(" Deleting the whole feed is irreversible, so make it a deliberate two\n         step action rather than a single click next to the close button. "),
        ($setup.confirmDeleteAll)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", null, "Delete all " + _toDisplayString($setup.backend.notifications.length) + " notifications?", 1 /* TEXT */),
              _createElementVNode("button", {
                class: "nge-notif-confirm-yes",
                onClick: $setup.doDeleteAll
              }, "Delete all"),
              _createElementVNode("button", {
                class: "nge-notif-confirm-no",
                onClick: _cache[3] || (_cache[3] = $event => ($setup.confirmDeleteAll = false))
              }, "Cancel")
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.backend.notifications.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.backend.notifications, (notif) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notif.id,
                  class: _normalizeClass(["nge-notif-card", { 'nge-notif-card--unread': !$setup.isRead(notif.id), 'nge-notif-card--triage': (notif.title || '').startsWith('🗂') }]),
                  onClick: $event => ($setup.openDetail(notif))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: notif.thumbnail_url || notif.image_url || $setup.pyrIcon,
                      class: _normalizeClass(["nge-notif-thumb-sm", { 'nge-notif-thumb-fallback': !notif.thumbnail_url && !notif.image_url }])
                    }, null, 10 /* CLASS, PROPS */, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (!$setup.isRead(notif.id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(notif.title), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_14, _toDisplayString($setup.relativeTime(notif.send_at)), 1 /* TEXT */),
                        ($setup.backend.isAdmin)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "nge-notif-delete",
                              onClick: _withModifiers($event => ($setup.backend.deleteNotification(notif.id)), ["stop"]),
                              title: "Delete notification (admin)"
                            }, "🗑", 8 /* PROPS */, _hoisted_15))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("button", {
                          class: "nge-notif-dismiss",
                          onClick: _withModifiers($event => ($setup.backend.dismissNotification(notif.id)), ["stop"]),
                          title: "Dismiss"
                        }, "×", 8 /* PROPS */, _hoisted_16)
                      ]),
                      _createElementVNode("div", _hoisted_17, _toDisplayString($setup.plainText(notif.body)), 1 /* TEXT */)
                    ])
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, " No notifications yet. "))
      ], 512 /* NEED_PATCH */), [
        [_vShow, $props.visible]
      ])
    ])),
    _createCommentVNode(" ═══ Detail overlay (separate Teleport so it's not clipped by panel) ═══ "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "nge-notif-detail" }, {
        default: _withCtx(() => [
          ($setup.openNotif)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nge-notif-detail-backdrop",
                onClick: _withModifiers($setup.closeDetail, ["self"])
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString($setup.relativeTime($setup.openNotif.send_at)), 1 /* TEXT */),
                    _createElementVNode("button", {
                      class: "nge-notif-detail-close",
                      onClick: $setup.closeDetail
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["nge-notif-detail-layout", { 'nge-notif-detail-layout--has-image': $setup.openNotif.image_url || $setup.openNotif.thumbnail_url }])
                    }, [
                      ($setup.openNotif.image_url || $setup.openNotif.thumbnail_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("img", {
                              src: $setup.openNotif.image_url || $setup.openNotif.thumbnail_url,
                              class: "nge-notif-detail-img",
                              onClick: _cache[4] || (_cache[4] = $event => ($setup.lightboxUrl = $setup.openNotif.image_url || $setup.openNotif.thumbnail_url))
                            }, null, 8 /* PROPS */, _hoisted_25)
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("h2", _hoisted_27, _toDisplayString($setup.openNotif.title), 1 /* TEXT */),
                        _createElementVNode("div", {
                          class: "nge-notif-detail-body",
                          innerHTML: $setup.renderMarkdown($setup.openNotif.body)
                        }, null, 8 /* PROPS */, _hoisted_28),
                        ($setup.isHelpNotification($setup.openNotif))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "nge-notif-open-help",
                              onClick: $setup.openHelpTab
                            }, "Open in Help tab →"))
                          : _createCommentVNode("v-if", true)
                      ])
                    ], 2 /* CLASS */)
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_19))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Lightbox for full-size images "),
      ($setup.lightboxUrl)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nge-notif-lightbox",
            onClick: _cache[5] || (_cache[5] = $event => ($setup.lightboxUrl = null))
          }, [
            _createElementVNode("img", {
              src: $setup.lightboxUrl,
              class: "nge-notif-lightbox-img"
            }, null, 8 /* PROPS */, _hoisted_29)
          ]))
        : _createCommentVNode("v-if", true)
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}